import type { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { CheckboxRenderer } from "../../../../../controls/ag-grid/components/CheckboxRenderer";
import { GridButtonsV2 } from "../../../../../controls/buttons/GridButtonsV2";
import type { CatalogSampleType } from "../models/CatalogSampleType";

const cellStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

type Props = {
  sampleTypes: CatalogSampleType[] | null;
  setSampleType: (sampleType: CatalogSampleType) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  showContextMenu: Function;
};

export const useTableData = ({
  sampleTypes,
  setSampleType,
  setShowModal,
  showContextMenu,
}: Props) => {
  const rows: CatalogSampleType[] =
    sampleTypes?.map((sampleType) => ({
      ...sampleType,
    })) || [];

  const columnDefs: ColDef[] = [
    {
      field: "SampleTypeName",
      headerName: "Name",
      minWidth: 20,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "IsActive",
      headerName: "Enabled",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
    },
    {
      field: "-",
      cellRenderer: GridButtonsV2,
      cellRendererParams: (params: ICellRendererParams) => ({
        setData: setSampleType,
        data: params.data as CatalogSampleType,
        del: false,
        setShowModal: setShowModal,
        showContextMenu: () =>
          showContextMenu(event, params.data, "sampleTypeContext"),
      }),
      wrapText: false,
      autoHeight: false,
      wrapHeaderText: false,
      headerName: "",
      sortable: false,
      flex: 1,
      minWidth: 330,
      filter: false,
      autoHeaderHeight: true,
    },
  ];

  return { rows, columnDefs };
};
